<template>
    <div :class="orientation">
        <div class="controls" v-if="orientation==='vertical'">
            <el-checkbox class="item" v-if="showSelectAll" v-model="checkAll" @change="changeCheckAll">全选</el-checkbox>
            <el-checkbox class="item" v-if="showInverse" v-model="checkedInverse" @change="changeCheckInverse">反选</el-checkbox>
        </div>
        <ul>
            <li  v-if="orientation==='vertical'">
                <el-checkbox class="data-range-item" v-model="groupCheck" @change="selectAllGroup">
                    <span class="text"><img v-if="showImg && groupObj.url" :src="groupObj.url" :alt="groupObj.name"> {{groupObj.name}}</span>
                </el-checkbox>
                <ul class="child-list">
                    <li v-for="item in groupChildList">
                        <ip-data-range-item :value="item.value" :countryAndAreaMapJson="countryAndAreaJson" :is-checked="item.check" :show-img="showChildImg"
                                            @dataRangeItemChanged="changeGroupChild"></ip-data-range-item>
                    </li>
                </ul>
            </li>
            <li v-for="item in displayedList">
                <ip-data-range-item :value="item.value" :countryAndAreaMapJson="countryAndAreaJson" :is-checked="item.check" :show-img="showImg"
                                    @dataRangeItemChanged="changeList"></ip-data-range-item>
            </li>
            <div class="controls" v-if="orientation!=='vertical'">
                <el-checkbox class="item" v-if="showSelectAll" v-model="checkAll" @change="changeCheckAll">全选</el-checkbox>
                <el-checkbox class="item" v-if="showInverse" v-model="checkedInverse" @change="changeCheckInverse">反选</el-checkbox>
            </div>
        </ul>
    </div>
</template>
<script>
    import countryAndAreaOptions from './countryAndAreaOptions'
    import ipDataRangeItem from './IpDataRangeItem'
    export default {
        name: 'ipDataRange',
        props: {
            displayedList: {
                type: Array
            },
            groupName: {
                type: String
            },
            groupChildList: {
                type: Array
            },
            showImg: {
                type: Boolean,
                default: true
            },
            showChildImg: {
                type: Boolean,
                default: false
            },
            orientation: {
                type: String,
                default: 'vertical'
            },
            showSelectAll: {
                type: Boolean,
                default: true
            },
            showInverse: {
                type: Boolean,
                default: true
            },
            countryAndAreaMapJson:{
                type:String,
                default:''
            }
        },
        components: {
            ipDataRangeItem
        },
        computed:{
            countryAndAreaJson(){
                return this.countryAndAreaMapJson
            }
        },
        mounted() {
            if(this.groupName){
                 if(this.groupName){
                     
                    if(this.countryAndAreaMapJson.length > 0){
                        var tempMap = this._jsonToMap(this.countryAndAreaMapJson);
                        if(tempMap && tempMap.size > 0){
                            this.groupObj = tempMap.get(this.groupName)
                        }
                    }else{
                        this.groupObj = countryAndAreaOptions.get(this.groupName)
                    }
                }
                if(this.showImg && this.groupObj.imgNo){
                    this.groupObj.url = require('../../../../public/image/country/country' + this.groupObj.imgNo + '.jpg')
               }

            }
            this.statisticalData()
        },
        data() {
            return {
                checkAll: false,
                checkedInverse: false,
                groupCheck: false,
                groupObj: {},
                resultList: []
            }
        },
        methods: {
            _objToStrMap(obj){
                let strMap = new Map();
                for (let k of Object.keys(obj)) {
                    strMap.set(k,obj[k]);
                }
                return strMap;
            },
            /**
             *json转换为map
            */
            _jsonToMap(jsonStr){
                return this._objToStrMap(JSON.parse(jsonStr));
            },
            changeCheckAll() {
                this.displayedList.forEach(el => el.check = this.checkAll)
                if(this.groupChildList){
                    this.groupCheck = this.checkAll
                    this.groupChildList.forEach(el => el.check = this.checkAll)
                }

                this.statisticalData()
            },
            changeCheckInverse() {
                this.displayedList.forEach(el => el.check = !el.check)
                if(this.groupChildList){
                    let temp = true;
                    this.groupChildList.forEach(el => {
                        el.check = !el.check;
                        if (!el.check) temp = false
                        });
                    this.groupCheck = temp;
                }
                this.statisticalData()
            },
            changeGroupChild(value,checked){
                this.groupChildList.forEach(el => {
                    if (el.value === value) el.check = checked
                })
                if (checked) {
                    let temp = true;
                    this.groupChildList.forEach(el => {
                        if (!el.check) temp = false
                    })
                    this.groupCheck = temp;
                    if (this.groupCheck) {
                        let temp1 = true;
                        this.displayedList.forEach(el => {
                            if (!el.check) temp1 = false
                        })
                        this.checkAll = temp1
                    }
                }else{
                    this.groupCheck = false;
                    this.checkAll = false;
                }
                this.statisticalData()
            },
            changeList(value, checked) {
                let self = this;
                this.displayedList.forEach(el => {
                    if (el.value === value) el.check = checked
                })
                if (checked) {
                    let temp = true;
                    this.displayedList.forEach(el => {
                        if (!el.check || !self.groupCheck) temp = false
                    })
                    this.checkAll = temp
                }else{
                    this.checkAll = false
                }
                this.statisticalData()
            },
            selectAllGroup(value) {
                if (!value) {
                    this.checkAll = false
                }else{
                    let temp = true;
                    this.displayedList.forEach(el => {
                        if (!el.check) temp = false
                    })
                    this.checkAll = temp
                }
                this.groupChildList.forEach(el=>el.check = this.groupCheck)
                this.statisticalData()
            },
            statisticalData(){
                let resultList = [];

                if(this.groupChildList){
                    this.groupChildList.forEach(el=>{
                        if(el.check)resultList.push(el.value)
                    })

                }
                this.displayedList.forEach(el=>{
                    if(el.check)resultList.push(el.value)
                })

                this.$emit('dataRangeChecked', resultList)
            }
        }

    }


</script>
<style lang="scss" scoped>
    ul, li, ol {
        margin: 0;
        padding: 0;
        list-style: none outside none;
    }
    li{
        display: inline-block;
    }
    .controls{
        padding-bottom: 10px;
        margin-bottom: 10px;
        .item{
            color: #148dd3;
            font-weight: bold;
            margin-right: 10px;
        }
      
    }
    .data-range-item {
        display: inline-block;
        margin-bottom: 5px;
        font-size: 14px;
        .text {
            display: inline-block;
            margin-left: 10px;
            img {
                border: 0;
                vertical-align: middle;
            }
        }

    }
    .vertical{
        li{
            display: block;
        }
        .controls{
            border-bottom: 1px dotted #cccccc;
        }
        .child-list {
            margin-left: 18px;
        }
    }
    .horizontal{
        li{
            display: inline-block;
            margin-right: 30px;
            margin-left: 0;
            line-height:30px;
        }
        .controls{
            border-top: 1px dotted #cccccc;
            line-height:30px;
        }
    }
</style>
<style lang="scss">
.controls{
  .el-checkbox__input.is-checked+.el-checkbox__label {
            color: #148dd3;
    }
}
</style>
